import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-incidencias-dashboard',
  templateUrl: './incidencias-dashboard.component.html',
  styleUrls: ['./incidencias-dashboard.component.css']
})
export class IncidenciasDashboardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
